"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPhysicsModel = exports.getPhysicsModel = exports.vector2Angle = exports.crossProduct = exports.angle2Vector = void 0;
exports.yawpitch2launchpoint = yawpitch2launchpoint;
exports.trainer2lift = trainer2lift;
exports.lift2trainer = lift2trainer;
exports.localization2physics = localization2physics;
exports.physics2localization = physics2localization;
exports.trainer2physics = trainer2physics;
exports.physics2trainer = physics2trainer;
exports.motorspin2ballspin = motorspin2ballspin;
exports.ballspin2motorspin = ballspin2motorspin;
exports.motorspin2spinlevel = motorspin2spinlevel;
exports.spinlevel2motorspin = spinlevel2motorspin;
exports.ballspin2spinlevel = ballspin2spinlevel;
exports.spinlevel2ballspin = spinlevel2ballspin;
exports.maxmotorspin_for_rpmspeed = maxmotorspin_for_rpmspeed;
exports.maxspinlevel_for_rpmspeed = maxspinlevel_for_rpmspeed;
exports.maxspinlevel = maxspinlevel;
exports.rpm2mps = rpm2mps;
exports.mps2rpm = mps2rpm;
exports.rpm2speedspin = rpm2speedspin;
exports.speedspin2rpm = speedspin2rpm;
exports.cameraHeight2HeadHeight = cameraHeight2HeadHeight;
exports.launchHeight2HeadHeight = launchHeight2HeadHeight;
exports.launchHeightInches2HeadHeight = launchHeightInches2HeadHeight;
const global_1 = require("./global");
var conversions_1 = require("../conversions");
Object.defineProperty(exports, "angle2Vector", { enumerable: true, get: function () { return conversions_1.angle2Vector; } });
Object.defineProperty(exports, "crossProduct", { enumerable: true, get: function () { return conversions_1.crossProduct; } });
Object.defineProperty(exports, "vector2Angle", { enumerable: true, get: function () { return conversions_1.vector2Angle; } });
var global_2 = require("./global");
Object.defineProperty(exports, "getPhysicsModel", { enumerable: true, get: function () { return global_2.getPhysicsModel; } });
Object.defineProperty(exports, "setPhysicsModel", { enumerable: true, get: function () { return global_2.setPhysicsModel; } });
function yawpitch2launchpoint(yawDeg, pitchDeg) {
    return (0, global_1.globalConversions)().yawpitch2launchpoint(yawDeg, pitchDeg);
}
function trainer2lift(pTrainer) {
    return (0, global_1.globalConversions)().trainer2lift(pTrainer);
}
function lift2trainer(pLift) {
    return (0, global_1.globalConversions)().lift2trainer(pLift);
}
function localization2physics(pLocalization) {
    return (0, global_1.globalConversions)().localization2physics(pLocalization);
}
function physics2localization(pPhysics) {
    return (0, global_1.globalConversions)().physics2localization(pPhysics);
}
function trainer2physics(pTrainer, pTrainerPosition, trainerYaw) {
    return (0, global_1.globalConversions)().trainer2physics(pTrainer, pTrainerPosition, trainerYaw);
}
function physics2trainer(pPhysics, pTrainerPosition, trainerYaw) {
    return (0, global_1.globalConversions)().physics2trainer(pPhysics, pTrainerPosition, trainerYaw);
}
function motorspin2ballspin(motorspinRPM) {
    return (0, global_1.globalConversions)().motorspin2ballspin(motorspinRPM);
}
function ballspin2motorspin(ballspinRPM) {
    return (0, global_1.globalConversions)().ballspin2motorspin(ballspinRPM);
}
function motorspin2spinlevel(motorspinRPM) {
    return (0, global_1.globalConversions)().motorspin2spinlevel(motorspinRPM);
}
function spinlevel2motorspin(spinLevel) {
    return (0, global_1.globalConversions)().spinlevel2motorspin(spinLevel);
}
function ballspin2spinlevel(ballspinRPM) {
    return (0, global_1.globalConversions)().ballspin2spinlevel(ballspinRPM);
}
function spinlevel2ballspin(spinlevel) {
    return (0, global_1.globalConversions)().spinlevel2ballspin(spinlevel);
}
function maxmotorspin_for_rpmspeed(angle, launch_speed_rpm) {
    return (0, global_1.globalConversions)().maxmotorspin_for_rpmspeed(angle, launch_speed_rpm);
}
function maxspinlevel_for_rpmspeed(angle, launch_speed_rpm) {
    return (0, global_1.globalConversions)().maxspinlevel_for_rpmspeed(angle, launch_speed_rpm);
}
function maxspinlevel(angle, speed) {
    return (0, global_1.globalConversions)().maxspinlevel(angle, speed);
}
function rpm2mps(rpm) {
    return (0, global_1.globalConversions)().rpm2mps(rpm);
}
function mps2rpm(mps) {
    return (0, global_1.globalConversions)().mps2rpm(mps);
}
function rpm2speedspin(rpms) {
    return (0, global_1.globalConversions)().rpm2speedspin(rpms);
}
function speedspin2rpm(speedSpin) {
    return (0, global_1.globalConversions)().speedspin2rpm(speedSpin);
}
function cameraHeight2HeadHeight(cameraHeightMeters) {
    return (0, global_1.globalConversions)().cameraHeight2HeadHeight(cameraHeightMeters);
}
function launchHeight2HeadHeight(launchHeightMeters) {
    return (0, global_1.globalConversions)().launchHeight2HeadHeight(launchHeightMeters);
}
function launchHeightInches2HeadHeight(launchHeightInches) {
    return (0, global_1.globalConversions)().launchHeightInches2HeadHeight(launchHeightInches);
}
